/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600",
  xxw: "1800",
  xxxw: "2000"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

let isMobile = false; // initiate as false
const isTouchDevice = !!("ontouchstart" in window);

if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
  isMobile = true;
}

/*  ==========================================================================
		Create a 100vh css variable
		========================================================================== */

const setViewHeight = function () {
  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  let vh = window.innerHeight;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};

setViewHeight();

window.addEventListener("resize", () => {
  setViewHeight();
});

/*  ==========================================================================
		GENERAL - add linklines to links
		========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll("a:not(.noline):not(.line-added)");
  links.forEach(function (el) {
    if (el.closest(".noline")) {
      return;
    }

    const icon = el.querySelector(".fa, .fa-solid, .fa-regular, .fa-light, .fa-thin, .fa-brands");

    if (el.querySelector("img") < 1) {
      const linkHTML = "<span class='linkline'>" + el.textContent + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line-added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".linkline").before(icon);
        } else {
          el.querySelector(".linkline").after(icon);
        }
      }
    }
  });
  //return true;
}; // linksInit();
//linksInit();

/*  ==========================================================================
    GENERAL - accordion
    ========================================================================== */

const accordionQuestions = document.querySelectorAll(".accordion__question");

const accordionInit = function (accordionItems) {
  if (!accordionItems) {
    return;
  }

  accordionItems.forEach(item =>
    item.addEventListener("click", function () {
      item.closest(".accordion__item").classList.toggle("accordion__item--open");
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (!item.closest(".accordion__item").classList.contains("accordion__item--open")) {
        panel.style.height = null;
      } else {
        panel.style.height = accordionCalculateMaxHeight(panel) + "px";
      }

      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    })
  );
  window.addEventListener("resize", function () {
    accordionItems.forEach(function (item) {
      if (item.closest(".accordion__item").classList.contains("accordion__item--open")) {
        let panel = item.nextElementSibling;
        panel.style.height = accordionCalculateMaxHeight(panel) + "px";
      }
    });

    setTimeout(function () {
      Waypoint.refreshAll();
    }, 500);
  });
}; // accordionInit();
accordionInit(accordionQuestions);

/*  ==========================================================================
    GENERAL - accordion: (Heigth helper functions)
    ========================================================================== */

function accordionCalculateMaxHeight(accordionAnswer) {
  const accordionEl = accordionAnswer.closest(".accordion");

  const canHover = window.matchMedia("(hover: hover)").matches; //Check if it's a touch device

  if (accordionEl.classList.contains("accordion--talent") && window.innerWidth > 700 && canHover) {
    // only on screens over 700
    const talentMediaImgs = accordionAnswer.querySelectorAll(".talent__media");
    let mediaMaxHeight = 0;
    talentMediaImgs.forEach(talentMedia => {
      let elementHeight = getHiddenHeight(talentMedia);
      mediaMaxHeight = !mediaMaxHeight || mediaMaxHeight < elementHeight ? elementHeight : mediaMaxHeight;
    });

    if (accordionAnswer.offsetHeight < mediaMaxHeight) {
      return mediaMaxHeight;
    }
  } else {
    return accordionAnswer.scrollHeight;
  }
}

function getHiddenHeight(el) {
  if (!el.cloneNode) {
    return null;
  }

  // For video we calculate the height based in the actual height and width video element
  if (el.querySelector("video")) {
    let containerWidth = el.parentNode.offsetWidth;

    let video = el.querySelector("video");
    let w = video.width;
    let h = video.height;

    let height = (h * containerWidth) / w;

    return height + 100;
  } else {
    const clone = el.cloneNode(true);

    Object.assign(clone.style, {
      overflow: "visible",
      width: "100%",
      height: "auto",
      maxHeight: "none",
      opacity: "0",
      visibility: "hidden",
      display: "block",
      padding: "2rem 0 3rem"
    });

    el.after(clone);
    const height = clone.offsetHeight;

    clone.remove();

    return height;
  }
}

/*  ==========================================================================
    GENERAL - Talent Accordion
========================================================================== */

const talentAccordionInit = function () {
  const accordionItems = document.querySelectorAll(".accordion--talent .accordion__item");

  if (!accordionItems) {
    return;
  }

  accordionItems.forEach(accordionItem => {
    const talentItems = accordionItem.querySelectorAll(".accordion--talent .talent__person");
    const talentMedia = accordionItem.querySelectorAll(".accordion--talent .talent__media");

    if (!talentMedia) {
      return;
    }

    talentItems.forEach(talentItem => {
      let id = talentItem.dataset.id;
      let targetMedia = accordionItem.querySelector(".talent__media[data-id='" + id + "']");
      if (targetMedia) {
        talentItem.addEventListener("mouseenter", function (e) {
          targetMedia.classList.add("active");
        });
        talentItem.addEventListener("mouseleave", function (e) {
          targetMedia.classList.remove("active");
        });
      }
    });
  });
}; // talentAccordionInit();
talentAccordionInit();

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
const lazyLoadInstance = new LazyLoad();

/* =======================================================================
  GENERAL - Share Icons
========================================================================== */
const socialLinksInit = function () {
  const socialLinks = document.querySelectorAll(".sociallink--popup");

  if (!socialLinks) {
    return;
  }

  socialLinks.forEach(socialLink =>
    socialLink.addEventListener("click", function (e) {
      e.preventDefault();
      const shareURL = this.getAttribute("href");
      var w = 550;
      var h = 550;
      var left = Number(screen.width / 2 - w / 2);
      var tops = Number(screen.height / 2 - h / 2);
      window.open(
        shareURL,
        "share-dialog",
        "resizable=no, width=" + w + ", height=" + h + ", top=" + tops + ", left=" + left + ""
      );
    })
  );
}; // socialLinksInit();
socialLinksInit();

/*  ==========================================================================
    GENERAL - Fancybox
  ========================================================================== */
const fancyboxInit = function () {
  const fancyboxOptions = {
    Hash: false, // Disabling Hash-based navigation, as it doesn't work on page reload
    Thumbs: false // Disable thumbnails
  };

  Fancybox.bind("[data-fancybox]", fancyboxOptions);
}; // fancyboxInit();

fancyboxInit();

/*  ==========================================================================
    GENERAL - Case Study tiles same heigth text areas
  ========================================================================== */

const rows = document.querySelectorAll(".module--casestudies--twocolumns");

const defaultCasestudyTilesInit = function (rows) {
  if (!rows) {
    return;
  }

  rows.forEach(row => {
    const rowTiles = row.querySelectorAll(".col--sameheighttext");
    let headingMaxHeight = 0;
    rowTiles.forEach(tile => {
      let tileHeading = tile.querySelector(".tile__heading");
      let elementHeight = tileHeading.offsetHeight;
      headingMaxHeight = !headingMaxHeight || headingMaxHeight < elementHeight ? elementHeight : headingMaxHeight;
    });

    rowTiles.forEach(tile => {
      let tileHeading = tile.querySelector(".tile__heading");
      console.log(headingMaxHeight);
      tileHeading.style.height = headingMaxHeight + "px";
      // tileHeading.offsetHeight = headingMaxHeight;
    });
  });
};

defaultCasestudyTilesInit(rows);

// Initialising for the single person template
const personWorkRows = document.querySelectorAll(".loadmore--personwork .row");
defaultCasestudyTilesInit(personWorkRows);

/*  ==========================================================================
    GENERAL - Initiate plyr (custom video controls)

    This is automatically disabled on builds, to enable uncomment the JS here
    and then go to functions / enqueue-scripts and enqueue-styles to uncomment and enable the css and JS 

    ========================================================================== */

const plyrsInit = function () {
  const videoPlyrs = document.querySelectorAll(".mediavideo:not(.mediavideo--autoplay) video");

  if (videoPlyrs) {
    videoPlyrs.forEach(function (el) {
      let plyr = new Plyr(el, {
        controls: ["play", "progress", "mute", "fullscreen"],
        hideControls: true,
        invertTime: false,
        muted: false,
        tooltips: { controls: false, seek: false }
      });
    });
  }

  const iframePlyrs = document.querySelectorAll(".mediavideo--iframe:not(.mediavideo--autoplay)");

  if (iframePlyrs) {
    iframePlyrs.forEach(function (el) {
      let plyr = el.querySelector(".mediavideo__video");
      const player = new Plyr(plyr, {
        controls: ["play", "progress", "mute", "fullscreen"],
        hideControls: true,
        invertTime: false,
        muted: false,
        tooltips: { controls: false, seek: false }
      });
    });
  }

  const pageheaderPlyrs = document.querySelectorAll(".pageheadervideo--controls video");

  if (pageheaderPlyrs) {
    pageheaderPlyrs.forEach(function (el) {
      let plyr = new Plyr(el, {
        controls: ["play", "progress", "mute", "fullscreen"],
        hideControls: true,
        invertTime: false,
        muted: false,
        tooltips: { controls: false, seek: false }
      });
    });
  }
}; // plyrsInit();

plyrsInit();

const hoverMediaInit = function () {
  const hoverMediaTile = document.querySelectorAll(".tile");

  if (!hoverMediaTile) {
    return;
  }

  hoverMediaTile.forEach(tile => {
    if (tile.querySelector(".tile__media--withhovermedia")) {
      let video = tile.querySelector(".tile__media__hover video");
      if (video) {
        tile.addEventListener("mouseover", function () {
          video.currentTime = 0;
          video.play();
        });

        tile.addEventListener("mouseleave", function () {
          video.pause();
          video.currentTime = 0;
        });
      }
    }
  });
};

//hoverMediaInit();

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

const loadmoreBtn = document.querySelector(".paging__loadmore");
const loadmoreContainer = document.querySelector(".loadmore-container");

const loadmoreLoadPostsMultiplePages = function (pages) {
  if (pages && pages > 1) {
    //Stopping default scroll back to previous position
    history.scrollRestoration = "manual";

    const currentPage = new URL(window.location);

    //Creating an array on page numbers to map it
    var list = [];
    for (var i = 1; i < pages; i++) {
      list.push(i);
    }

    // Initialising the array of posts pages
    var postsHTML = [];

    const button = loadmoreBtn;
    const buttonText = button.innerHTML; // store current button text
    button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts

    // Array of ajax calls
    var allAJAX = list.map(function (page) {
      const data = {
        action: "loadmore",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function
        exclude: php_variables.exclude_posts,
        page: page,
        postid: php_variables.postid,
        offset: php_variables.offset,
        layout: php_variables.layout
      };
      //Updating the url to mtch the page number
      currentPage.searchParams.set("pagenum", page);

      if (loadmoreContainer && loadmoreContainer.classList.contains("loadmore--personwork")) {
        php_variables.offset = php_variables.offset + 6;
      }

      return $.ajax({
        url: php_variables.ajax_url, // AJAX handler
        data: data,
        type: "POST",
        success: function (data) {
          postsHTML[page] = data;
        }
      });
    });

    // Waiting for all the ajax calls to be finished before proceeding
    Promise.all(allAJAX).then(function () {
      // Update current page variable
      php_variables.current_page = pages;

      button.innerHTML = buttonText; // set back to previous button text

      // Adding the new tiles to the dom
      list.map(page => {
        if (postsHTML[page]) {
          loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + postsHTML[page];
        }
      });

      // Updating the href for the loadmore button
      const nextPage = new URL(window.location);
      nextPage.searchParams.set("pagenum", parseInt(pages) + 1);
      button.href = nextPage;

      // if last page, remove the button..
      if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
        button.style.display = "none";
      }

      // Re-init lazy load
      lazyLoadInstance.update(); // reinit lazy load after clones
      // Re-init effects
      const effects = document.querySelectorAll(".effect");
      effectsInit(effects);

      // Scrolling the page to the last known position
      if (localStorage.getItem("scrollPosition")) {
        window.scroll({
          top: parseInt(localStorage.getItem("scrollPosition"), 10),
          behavior: "instant"
        });
      }
    });
  }
};

const loadmoreLoadPosts = function (e) {
  if (e) {
    e.preventDefault(); // Preventing the a tag from redirecting to the page
  }

  const button = document.querySelector(".paging__loadmore");

  const data = {
    action: "loadmore",
    query: php_variables.posts, // that's how we get params from wp_localize_script() function
    exclude: php_variables.exclude_posts,
    postid: php_variables.postid,
    offset: php_variables.offset,
    page: php_variables.current_page,
    layout: php_variables.layout,
    border: php_variables.border
  };
  let buttonText; // create variable to store button text

  // This AJAX triggers a PHP hook within functions-ajax.php called ajax_loadmore_handler
  $.ajax({
    url: php_variables.ajax_url, // AJAX handler
    data: data,
    type: "POST",
    beforeSend: function (xhr) {
      buttonText = button.textContent; // store current button text
      button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts
    },
    success: function (data) {
      if (data) {
        button.textContent = buttonText; // set back to previous button text
        loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + data; // insert new posts to the loadmore-container, this should be the row that includes the posts
        php_variables.current_page++;

        if (loadmoreContainer && loadmoreContainer.classList.contains("loadmore--personwork")) {
          php_variables.offset = php_variables.offset + 6;
        }

        // Only push state to set the last page number or if there is more pages to load
        const currentPage = new URL(window.location);

        if (parseInt(php_variables.current_page) <= parseInt(php_variables.max_page)) {
          currentPage.searchParams.set("pagenum", php_variables.current_page);
          history.pushState({}, "", currentPage);
        }

        //Updating the loadmore link
        const nextPage = new URL(window.location);
        nextPage.searchParams.set("pagenum", parseInt(php_variables.current_page) + 1);

        button.href = nextPage;

        // if last page, remove the button..
        if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
          button.style.display = "none";
        }
        // Re-init links to make sure linklines on newly loaded content still work
        linksInit();
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init effects
        const effects = document.querySelectorAll(".effect");
        effectsInit(effects);
        autoplayingVideosInit();
        defaultCasestudyTilesInit(document.querySelectorAll(".loadmore--work .row"));
      } else {
        button.style.display = "none"; // if no data, remove the button as well
      }
    }
  });
}; // loadmoreLoadPosts();

const loadmoreInit = function () {
  if (!loadmoreBtn || !loadmoreContainer) {
    return;
  }
  /** When adding fitering you will need to move this part into the filtering call */
  // Checking if the page paramenter is set
  const currentPage = new URL(window.location);
  let currentPageNum = currentPage.searchParams.get("pagenum");

  // If we are on a work category page
  if (loadmoreContainer && loadmoreContainer.classList.contains("loadmore--work")) {
    let excludeWork = loadmoreContainer.dataset.exclude;
    php_variables.exclude_posts = excludeWork;
    let tileLayout = loadmoreContainer.dataset.layout;
    let tileBorder = loadmoreContainer.dataset.border;
    php_variables.layout = tileLayout;
    php_variables.border = tileBorder;
    php_variables.current_page = 0;
  } else if (loadmoreContainer && loadmoreContainer.classList.contains("loadmore--personwork")) {
    php_variables.max_page = loadmoreContainer.dataset.maxpage;
    php_variables.offset = 6;
    php_variables.postid = loadmoreContainer.dataset.postid;
  }

  //If there is more than one page to load
  if (currentPageNum && currentPageNum > 1) {
    currentPageNum = currentPageNum > php_variables.max_page ? php_variables.max_page : currentPageNum;
    loadmoreLoadPostsMultiplePages(currentPageNum);
  }

  /** -end- */

  // Saving the scroll position before unload
  window.addEventListener("unload", function (e) {
    var scrollPosition = window.scrollY;
    localStorage.setItem("scrollPosition", scrollPosition);
  });

  loadmoreBtn.addEventListener("click", loadmoreLoadPosts);
}; // loadmoreInit();

loadmoreInit();

/*  ==========================================================================
    Animations: Scroll effects
    ========================================================================== */

const effects = document.querySelectorAll(".effect");

const effectsInit = function (effects) {
  if (!effects) {
    return;
  }

  effects.forEach(function (val) {
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        if (direction === "down") {
          val.classList.add("effect--ready");
          lazyLoadInstance.update();
        } else {
          val.classList.remove("effect--ready");
        }
      },
      offset: "90%"
    });
  });
}; // effectsInit();
effectsInit(effects);

/*  ==========================================================================
    Animations - Talent List Animation (Mouse Triggered)
========================================================================== */

const talentItems = document.querySelectorAll(".module--feature-talent .person__media");

const mouseMoveHandler = function (e) {
  talentItems.forEach(item => {
    let itemRect = item.getBoundingClientRect();
    var valueX = (e.clientX - itemRect.left) / 10;
    var valueY = (e.clientY - itemRect.top) / 10;

    gsap.to(item, { x: valueX, y: valueY, duration: 1 });
  });
};

const throttled = function (delay, fn) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
};

const talentListAnimationInit = function () {
  const talentItemsWrapper = document.querySelector(".module--feature-talent .talent");
  const talentItems = document.querySelectorAll(".module--feature-talent .person--talent");

  if (talentItems && talentItemsWrapper) {
    const moveHandler = throttled(200, mouseMoveHandler);
    talentItemsWrapper.onmousemove = moveHandler;
  }
};

talentListAnimationInit();

/*  ==========================================================================
  Animations - Social Ticker
========================================================================== */

const socialticker = document.querySelectorAll(".socialticker");

const socialtickerInit = function () {
  if (!socialticker || socialticker.length < 1) {
    return;
  }

  const root = document.documentElement;
  const marqueeElementsDisplayed = getComputedStyle(root).getPropertyValue("--marquee-elements-displayed");
  const allMarqueeContent = document.querySelectorAll(".socialticker__track");
  const marqueeContent = () => {
    allMarqueeContent.forEach(marquee => {
      root.style.setProperty("--marquee-elements", marquee.children.length);
      for (let i = 0; i < marqueeElementsDisplayed; i++) {
        marquee.appendChild(marquee.children[i].cloneNode(true));
      }
      return marquee;
    });
  };

  marqueeContent();

  // GSAP scroll trigger marquee elements
  gsap.to(".socialticker", {
    scrollTrigger: {
      trigger: ".socialticker",
      scrub: 0.65,
      start: "top bottom",
      end: "bottom top",
      ease: "power2",
      toggleActions: "restart"
    },
    xPercent: -30
  });
};

socialtickerInit();

/*  ==========================================================================
  Text animations
  ========================================================================== */

const breakInWords = function (elem) {
  let original = elem.textContent;
  let className = "word";

  var text = elem.textContent
    .split(" ")
    .map(function (item, index) {
      if (item && item.length > 0) {
        return (
          '<span class="' + className + (index + 1) + '" aria-hidden="true"><span>' + item + "</span>&nbsp;</span>"
        );
      }
    })
    .join("");
  elem.setAttribute("aria-label", original);
  elem.innerHTML = text;
};

const textreveal = document.querySelectorAll(".text-reveal");

const textRevealInit = function () {
  if (!textreveal || textreveal.length < 1) {
    return;
  }

  textreveal.forEach(item => {
    if (!item.classList.contains(".text-reveal--ready")) {
      breakInWords(item);

      const waypoints = new Waypoint({
        element: item,
        handler: function (direction) {
          if (direction === "down") {
            item.classList.add("text-reveal--ready");
          } else {
            item.classList.remove("text-reveal--ready");
          }
        },
        offset: "85%"
      });
    }
  });
};

textRevealInit();

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const gridCarousels = document.querySelectorAll(".row--carousel .owl-carousel");

const gridCarouselInit = function (gridCarousels) {
  if (gridCarousels.length <= 0) {
    return;
  }

  gridCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoHeight && elem.dataset.autoHeight === "disable" ? false : true;

    var owlCarousel = $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      dots: dots,
      items: 1,
      navText: ["<i class='fa-light fa-arrow-left'></i>", "<i class='fa-light fa-arrow-right'></i>"],
      responsive: responsiveArray,
      startPosition: slides.length,
      autoHeight: autoHeight,
      onInitialized: function () {
        lazyLoadInstance.update();
        Waypoint.refreshAll();
      }
    });

    // Safari iOS fix, causing a 1px height until a carousel change happened
    var adjustCarouselHeight = setInterval(function () {
      if (owlCarousel.height() > 1) {
        clearInterval(adjustCarouselHeight);
      }
      owlCarousel.trigger("refresh.owl.carousel", [100]);
    }, 300);

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // gridCarouselInit();
gridCarouselInit(gridCarousels);

/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carouselResponsiveArray(elem) {
  let responsiveArray = {};
  const slides = elem.querySelectorAll(".col");
  const classes = slides[0].classList;

  classes.forEach((cl, index) => {
    if (cl.indexOf("col-") !== -1) {
      let className = cl;
      let classWidth = 0;
      let numItems = 4;
      className = cl.replace("col-", "");
      // get min width from col class
      const classGridsize = className.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(classGridsize)) {
        className = className.replace(classGridsize + "-", "");
        classWidth = gridSizes[classGridsize];
      } else {
        classWidth = 0;
      }
      // split rest of class into sections (this should now be something like '1-4')
      const otherClassParts = className.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      if (otherClassParts[1]) {
        numItems = otherClassParts[1] / otherClassParts[0];
      } else {
        numItems = 1; // if there isn't a second number it must be a single grid
      }
      responsiveArray[classWidth] = {
        items: numItems //+ 0.5 // this shows the number of items and 1/2
      };
    }
  });

  return responsiveArray;
} // carouselResponsiveArray();

const edgeCarousels = document.querySelectorAll(".edge-carousel");

const edgeCarouselInit = function (edgeCarousels) {
  if (edgeCarousels.length <= 0) {
    return;
  }

  edgeCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    var owlCarousel = $(elem).owlCarousel({
      margin: 0,
      autoWidth: true,
      items: 1,
      nav: false,
      loop: true,
      dots: false,
      onInitialized: function () {
        lazyLoadInstance.update();
        Waypoint.refreshAll();
      }
    });

    // Safari iOS fix, causing a 1px height until a carousel change happened
    var adjustCarouselHeight = setInterval(function () {
      if (owlCarousel.height() > 1) {
        clearInterval(adjustCarouselHeight);
      }
      owlCarousel.trigger("refresh.owl.carousel", [100]);
    }, 300);

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // edgeCarouselInit();
edgeCarouselInit(edgeCarousels);

/*  ==========================================================================
	NAVIGATION - mobnav
	========================================================================== */

const mobnav = document.querySelector(".mobnav");
const siteHeaderBd = document.querySelector(".siteheader__bd");
const mobnavToggles = document.querySelectorAll(".mobnav-toggle");
const mobnavOpenclass = "mobnavopen";

const mobnavInit = function () {
  // Open mobnav on click the toggle
  mobnavToggles.forEach(toggle => {
    toggle.addEventListener("click", function (e) {
      e.preventDefault();
      if (!body.classList.contains(mobnavOpenclass)) {
        // IT'S NOT OPEN...
        body.classList.add(mobnavOpenclass);
        setTimeout(() => {
          mobnav.classList.add("loaded");
        }, "200");
      } else {
        // IT'S OPEN...
        body.classList.remove(mobnavOpenclass);
        mobnav.classList.remove("loaded");
      }
    });
  });
}; // mobnavInit()
mobnavInit();

/*  ==========================================================================
	NAVIGATION - Escaping mobilenav and worknav on esc key
	========================================================================== */

window.addEventListener("keydown", function (event) {
  // Escaping the dropdown on tab navigation
  if (event.key === "Escape") {
    if (body.classList.contains(mobnavOpenclass)) {
      body.classList.remove(mobnavOpenclass);
    }
  }
});

window.addEventListener("click", function (event) {
  // closing the extended navigation on click outside

  if (
    !event.target.classList.contains("mobnav-toggle") &&
    body.classList.contains(mobnavOpenclass) &&
    event.target !== mobnav &&
    !mobnav.contains(event.target)
  ) {
    body.classList.remove(mobnavOpenclass);
  }
});

/*  ==========================================================================
	NAVIGATION - Hide siteheader on scroll down, show on scroll up
	========================================================================== */

const siteheader = document.querySelector(".siteheader:not(.siteheader--padder)");

const siteheaderInit = function () {
  let prevScrollPos = window.scrollY;

  /* Get the header element and it's position */
  let headerBottom = siteheader.offsetTop + siteheader.offsetHeight;

  window.onscroll = function () {
    let currentScrollPos = window.scrollY;

    /* if scrolling down, let it scroll out of view as normal */
    if (prevScrollPos < currentScrollPos && currentScrollPos > 0) {
      siteheader.classList.add("hideNav");
      if (searchNav) {
        searchNav.classList.remove("sitenav__search--open");
      }
    } else {
      /* otherwise if we're scrolling up, fix the nav to the top */
      siteheader.classList.remove("hideNav");
      if (currentScrollPos > 0) {
        siteheader.classList.add("showNav");
      } else {
        siteheader.classList.remove("showNav");
      }
    }

    prevScrollPos = currentScrollPos;
  };
};

siteheaderInit();

/*  ==========================================================================
	NAVIGATION - Search
	========================================================================== */

// Search open & close
const searchNav = document.querySelector(".sitenav__search");
const searchToggle = document.querySelector(".search-toggle");
const searchInput = document.querySelector(".sitenav__search .searchform__input input");

const searchNavOpenclass = "searchnavopen";

// Close search modal when clicked elsewhere in the document
const clickedOusideSearch = function (e) {
  if (!searchNav.classList.contains("sitenav__search--open")) {
    return;
  }

  var isClickInsideElement =
    searchNav.contains(e.target) || searchToggle === e.target || searchToggle.contains(e.target);

  if (!isClickInsideElement) {
    searchNav.classList.remove("sitenav__search--open");
    body.classList.remove(searchNavOpenclass);
    body.removeEventListener("mouseup", clickedOusideSearch, false);
  }
}; // clickedOusideSearch();

// Toggle search modal window
const searchModalToggle = function (e) {
  e.preventDefault();
  if (searchNav.classList.contains("sitenav__search--open")) {
    searchNav.classList.remove("sitenav__search--open");
    body.classList.remove(searchNavOpenclass);
    body.removeEventListener("mouseup", clickedOusideSearch, false);
  } else {
    searchNav.classList.add("sitenav__search--open");
    body.classList.add(searchNavOpenclass);
    searchInput.focus();
    body.addEventListener("mouseup", clickedOusideSearch, false);
  }
}; // searchModalToggle();

const searchModalInit = function () {
  if (!searchNav) {
    return;
  }
  searchToggle.addEventListener("click", searchModalToggle);
}; // searchModalInit();

searchModalInit();

/*  ==========================================================================
	FORM - Trigger after Form Submission
	========================================================================== */

const triggerAfterSubmit = function () {
  jQuery(document).on("gform_confirmation_loaded", function (event, formId) {
    Waypoint.refreshAll();
  });
};

triggerAfterSubmit();
